// extracted by css-extract-rspack-plugin
export default {"cls1":"LearningPoints-cls1_ZhQ","cls2":"LearningPoints-cls2_ea2 LearningPoints-cls1_ZhQ","singleColumn":"LearningPoints-singleColumn_Rwv"};